class EnovarBoardRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = "EnovarBoard";

    super(entityName);

    this.tokenInfo = null;
  }

  makeForm = () => {
    Monet.Session.Security.permissions.push({
      key: "ENOVAR",
      authority: "ENOVAR"
    });
    this.createIFrame();
  };

  adjustUrl = config => {
    const url = config.resource.url.trim();
    const position = url.length - 1;
    const char = url.charAt(position);
    if (char !== "/") {
      config.resource.url = `${url}/`;
    }
    return config;
  };

  requestAuthenticationInfo = () => {
    var request = new Monet.Ajax();
    request.url = "enovar/getToken";
    request.method = "GET";
    request.data = this.criteria;
    request.success = tokenInfo => {
      this.tokenInfo = this.adjustUrl(tokenInfo);
      this.addPostMessageListener();
      this.createAuthenticationForm();
    };
    request.error = () => true;
    request.send();
  };

  logout = callback => {
    console.log("[EnovarBoard] Logout");
    this.iframe.src = this.tokenInfo.resource.url + "logout";
    setTimeout(() => callback(), 200);
  };

  createAuthenticationForm = () => {
    var urlBsboard = this.tokenInfo.resource.url + "login";
    var form = document.createElement("form");
    var login = document.createElement("input");
    var button = document.createElement("input");
    var tabContainer = document.getElementById("Analytics");

    form.setAttribute("method", "POST");
    form.setAttribute("action", urlBsboard);
    form.setAttribute("target", "enovarIframe");

    login.setAttribute("name", "token");
    login.setAttribute("type", "hidden");
    login.setAttribute("value", this.tokenInfo.resource.token);

    button.type = "submit";
    button.value = "You are not suppose to see it";
    button.style.visibility = "hidden";
    button.style.position = "absolute";

    form.appendChild(button);

    form.appendChild(login);

    tabContainer.appendChild(form);

    this.logout(() => {
      this.updateIframeInfo();
      button.click();
    });
  };

  createIFrame = () => {
    var previousDashboard = document.querySelector("#Analytics iframe");
    var tabContainer = document.getElementById("Analytics");
    this.iframe = document.createElement("iframe");
    this.iframe.sandbox = "allow-scripts allow-forms allow-same-origin allow-downloads allow-modals allow-presentation";

    if (!previousDashboard) {
      this.iframe.src = "";
      this.iframe.style.width = "100%";
      this.iframe.style.border = "0";
      this.iframe.style.height = window.innerHeight - 113 + "px";
      this.iframe.id = "enovarIframe";
      this.iframe.name = "enovarIframe";

      tabContainer.appendChild(this.iframe);

      window.addEventListener("resize", () => {
        var existIframe = document.getElementById("enovarIframe");

        if (existIframe) {
          existIframe.style.height = window.innerHeight - 103 + "px";
        }
      });
    }

    this.requestAuthenticationInfo();
  };

  updateIframeInfo = () => {
    this.iframe.src = this.tokenInfo.resource.url + "login";
    console.log("[EnovarBoard] Login");
  };

  addPostMessageListener = () => {
    window.addEventListener(
      "message",
      message => {
        if (
          message.origin === this.tokenInfo.resource.url.replace("/app/", "") &&
          message.data.type === "NO_SESSION"
        ) {
          this.requestAuthenticationInfo();
        }
      },
      false
    );
  };
}

App.Routers.EnovarBoard = EnovarBoardRouter;
